import {h, Fragment, Component} from 'preact';
import {createRef} from 'preact/compat';
import PropTypes from 'prop-types';

export default class InputAutocomplete extends Component {
	static propTypes = {
		defaultValue: PropTypes.string,
		defaultDisplayValue: PropTypes.string,
		placeholder: PropTypes.string,
		autocompleteOptions: PropTypes.shape({
			minLength: PropTypes.number.isRequired,
			source: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.func]).isRequired
		}).isRequired,
		autoSearch: PropTypes.bool,
		valueInputItemKey: PropTypes.string,
		itemTpl: PropTypes.string,
		onSelect: PropTypes.func,
		autocompleteselect: PropTypes.func,
		disabled: PropTypes.bool,
	};

	constructor(props){
		super(props);

		this.inputRef = createRef();

		this.state = {
			value: props.defaultValue,
			displayValue: props.defaultDisplayValue,
		}
	}

	componentDidMount(){
		this.registerJqueryAutocomplete();
	}

	render(props, state, context){
		return (
			<input
				ref={this.inputRef}
				className="input form-field__input"
				type="text"
				disabled={props.disabled}
				placeholder={props.placeholder}
			/>
		)
	}

	triggerChange(value, displayValue){
		const {onSelect} = this.props;
		this.setState({value, displayValue});
		if(!!onSelect && typeof onSelect === "function")
		{
			onSelect(value, displayValue);
		}
	}

	registerJqueryAutocomplete(){
		if(!this.inputRef.current || this.props.disabled) return;

		const self = this;
		const props = this.props;
		const getValue = () => this.state.value || '';
		const getDisplayValue = () => this.state.displayValue;

		let $input = $(this.inputRef.current);
		$input.val(this.state.displayValue || '');

		$input.autocomplete({
			...props.autocompleteOptions,
			create: function(event, ui){
				$input.on('blur', function(){
					if(getValue().length > 0)
					{
						if($input.val())
						{
							$input.val(getDisplayValue());
						}
						else
						{
							self.triggerChange('', '');
							$input.val('');
						}
					}
					else $input.val('');
				});

				if(props.itemTpl)
				{
					$input.autocomplete("instance")._renderItem = function(ul, item){
						let itemTpl = props.itemTpl;

						for(let key in item)
						{
							let value = '';
							if(item.hasOwnProperty(key)) value = item[key];
							itemTpl = itemTpl.replace(new RegExp('\{' + key + '\}', 'g'), value);
						}

						return $("<li>").append(itemTpl).appendTo(ul);
					};
				}

				if(props.autoSearch)
				{
					let autoSearchOn = false;
					$input.on('focus click', function(){
						if(!autoSearchOn && !$input.autocomplete("instance").menu.element.is(':visible'))
						{
							autoSearchOn = true;
							$input.autocomplete('search');
						}
					});
					$input.on('autocompleteresponse', function(){
						setTimeout(function(){
							autoSearchOn = false;
						}, 300);
					});
				}
			}
		});

		$input.on('autocompleteselect', function(event, ui){
			self.triggerChange(ui.item[props.valueInputItemKey || 'id'], ui.item.value || ui.item.label);
		});

		if(!!props.autocompleteselect && typeof props.autocompleteselect === "function")
		{
			$input.on('autocompleteselect', props.autocompleteselect);
		}
	}
}